import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 32px 24px 64px;
  background: linear-gradient(135deg, #0e1215 0%, #1b463a 50%, #262d34 100%);
  overflow-y: auto;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 48px;
`;

export const Title = styled.h1`
  font-size: 48px;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 8px;
  letter-spacing: 2px;
  text-transform: uppercase;
  background: linear-gradient(90deg, #0abb87, #91ddb9, #0abb87);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: ${shimmer} 3s linear infinite;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  letter-spacing: 1px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  text-align: center;
  gap: 16px;
`;
